export const SPIRIT_ASSETS = [
 '/assets/ar-spirits/storm-wraith.webp',
 '/assets/ar-spirits/drowned-spirit.webp',
 '/assets/ar-spirits/fox-revenant.webp',
 '/assets/ar-spirits/horned-yaksha.webp',
 '/assets/ar-spirits/shadow-dragon.webp',
 '/assets/ar-spirits/haunted-doll.webp',
 '/assets/ar-spirits/bone-knight.webp',
 '/assets/ar-spirits/spider-widow.webp',
 '/assets/ar-spirits/lantern-reaper.webp',
 '/assets/ar-spirits/frost-wraith.webp',
] as const;

export function loadSpiritArt(): { images: HTMLImageElement[]; ready: Promise<void> } {
 const images = SPIRIT_ASSETS.map(() => new Image());
 const ready = Promise.all(images.map((image, index) => new Promise<void>((resolve, reject) => {
  image.decoding = 'async';
  image.onload = () => { void image.decode().then(resolve, reject); };
  image.onerror = () => reject(new Error('귀신 이미지 로딩 실패'));
  image.src = SPIRIT_ASSETS[index];
 }))).then(() => undefined);
 return { images, ready };
}
